"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _I18n = _interopRequireDefault(require("I18n"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _classnames = _interopRequireDefault(require("classnames"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _colors = require("HubStyleTokens/colors");

var _sizes = require("HubStyleTokens/sizes");

var _UIIconHolder = _interopRequireDefault(require("../icon/UIIconHolder"));

var _BrowserTest = require("../utils/BrowserTest");

var _createLazyPropType = _interopRequireDefault(require("../utils/propTypes/createLazyPropType"));

var _lazyEval = _interopRequireDefault(require("../utils/lazyEval"));

var _tshirtSize = require("../utils/propTypes/tshirtSize");

var _memoizeOne = _interopRequireDefault(require("react-utils/memoizeOne"));

var _LoadingConstants = require("./LoadingConstants");

function _templateObject10() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  stroke: ", ";\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  animation: ", " 2s cubic-bezier(0.42, 0, 0.58, 1) infinite,\n    ", " 2s linear infinite;\n  stroke: ", ";\n  stroke-dasharray: none;\n  stroke-dashoffset: 0;\n  stroke-linecap: round;\n  transform-origin: center;\n  ", "\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  stroke: ", ";\n  display: block;\n  max-width: 100%;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  opacity: 1;\n  transition: opacity 0.2s cubic-bezier(0.42, 0, 0.58, 1),\n    transform 0.2s cubic-bezier(0.89, 0.03, 0.68, 0.22);\n  ", "\n\n  ", "\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  opacity: 0;\n  position: absolute;\n  transform: scale(0.7);\n  transition: opacity 0.2s cubic-bezier(0.42, 0, 0.58, 1) 0.1s,\n    transform 0.3s cubic-bezier(0.2, 0.9, 0.3, 2) 0.1s;\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin-top: ", ";\n\n  &:not(:empty) {\n    margin-left: ", ";\n    margin-right: ", ";\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  align-items: center;\n  display: flex;\n  height: ", ";\n  justify-content: center;\n  width: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: relative;\n  align-items: center;\n  color: ", ";\n  display: flex;\n  flex-direction: ", ";\n  justify-content: ", ";\n  ", ";\n  margin: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  0% {\n    stroke-dasharray: 1, 150;\n    stroke-dashoffset: 0;\n  }\n  50% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -50;\n  }\n  100% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -140;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  100% {\n    transform: rotate(360deg)\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var getSpinnerSize = function getSpinnerSize(sizeName) {
  return _LoadingConstants.SIZE_OPTIONS[sizeName] || _LoadingConstants.SIZE_OPTIONS['small'];
};

var privateSpin = (0, _styledComponents.keyframes)(_templateObject());
var privateDash = (0, _styledComponents.keyframes)(_templateObject2());
var SpinnerOuter = (0, _styledComponents.default)(function (props) {
  var __use = props.use,
      __grow = props.grow,
      rest = (0, _objectWithoutProperties2.default)(props, ["use", "grow"]);
  return _react.default.createElement("div", rest);
}).withConfig({
  displayName: "UILoadingSpinner__SpinnerOuter",
  componentId: "cg1l6x-0"
})(_templateObject3(), function (props) {
  return props.use === 'on-dark' ? _colors.OLAF : 'currentColor';
}, function (props) {
  return props.layout === 'centered' && 'column';
}, function (props) {
  return props.layout === 'centered' && 'center';
}, function (props) {
  return props.grow && "width: 100%; height: 100%;";
}, function (props) {
  return !props.grow && '8px';
});

var SpinnerInner = _styledComponents.default.div.withConfig({
  displayName: "UILoadingSpinner__SpinnerInner",
  componentId: "cg1l6x-1"
})(_templateObject4(), function (props) {
  return getSpinnerSize(props.size);
}, function (props) {
  return getSpinnerSize(props.size);
});

var SpinnerLabel = _styledComponents.default.span.withConfig({
  displayName: "UILoadingSpinner__SpinnerLabel",
  componentId: "cg1l6x-2"
})(_templateObject5(), function (props) {
  return props.layout === 'centered' && _sizes.BASE_ICON_SPACING_X;
}, _sizes.BASE_ICON_SPACING_X, _sizes.BASE_ICON_SPACING_X);

var ResultSpinner = (0, _styledComponents.default)(function (props) {
  var __displayResult = props.displayResult,
      rest = (0, _objectWithoutProperties2.default)(props, ["displayResult"]);
  return _react.default.createElement("div", rest);
}).withConfig({
  displayName: "UILoadingSpinner__ResultSpinner",
  componentId: "cg1l6x-3"
})(_templateObject6(), function (_ref) {
  var displayResult = _ref.displayResult;
  return displayResult && "opacity: 1;\n    position: relative;\n    transform: scale(1);\n  ";
});
var SpinnerWrapper = (0, _styledComponents.default)(function (props) {
  var __displayResult = props.displayResult,
      rest = (0, _objectWithoutProperties2.default)(props, ["displayResult"]);
  return _react.default.createElement("div", rest);
}).withConfig({
  displayName: "UILoadingSpinner__SpinnerWrapper",
  componentId: "cg1l6x-4"
})(_templateObject7(), (0, _BrowserTest.isIE11)() && "animation: " + privateSpin + " 2s linear infinite;", function (_ref2) {
  var displayResult = _ref2.displayResult;
  return displayResult && "margin-left: -1px;\n    opacity: 0;\n    transform: scale(.7);\n    width: 1px;\n  ";
});
var Ring = (0, _styledComponents.default)(function (props) {
  var __use = props.use,
      rest = (0, _objectWithoutProperties2.default)(props, ["use"]);
  return _react.default.createElement("svg", rest);
}).withConfig({
  displayName: "UILoadingSpinner__Ring",
  componentId: "cg1l6x-5"
})(_templateObject8(), function (_ref3) {
  var use = _ref3.use;
  return _LoadingConstants.USE_COLORS[use];
});
var RingPath = (0, _styledComponents.default)(function (props) {
  var __use = props.use,
      rest = (0, _objectWithoutProperties2.default)(props, ["use"]);
  return _react.default.createElement("circle", rest);
}).withConfig({
  displayName: "UILoadingSpinner__RingPath",
  componentId: "cg1l6x-6"
})(_templateObject9(), privateDash, privateSpin, function (_ref4) {
  var use = _ref4.use;
  return _LoadingConstants.USE_INDICATOR_COLORS[use];
}, (0, _BrowserTest.isIE11)() && "stroke-dasharray: 50, 150;");
var RingBackground = (0, _styledComponents.default)(function (props) {
  var __use = props.use,
      rest = (0, _objectWithoutProperties2.default)(props, ["use"]);
  return _react.default.createElement("circle", rest);
}).withConfig({
  displayName: "UILoadingSpinner__RingBackground",
  componentId: "cg1l6x-7"
})(_templateObject10(), function (_ref5) {
  var use = _ref5.use;
  return _LoadingConstants.USE_COLORS[use];
});

var getClassName = function getClassName(className, use) {
  return (0, _classnames.default)('private-spinner', className, _LoadingConstants.USE_CLASSES[use]);
};

var getIconSize = function getIconSize(longhandSize) {
  return _LoadingConstants.ICON_SIZE_MAP[longhandSize] || _LoadingConstants.ICON_SIZE_MAP['small'];
};

var getIconColor = function getIconColor(use) {
  return _LoadingConstants.ICON_COLOR_MAP[use];
};

var renderIcon = function renderIcon(failed, resultIcon, longhandSize, use, displayResult) {
  if (failed || !resultIcon) {
    return null;
  }

  return _react.default.createElement(ResultSpinner, {
    displayResult: displayResult
  }, _react.default.createElement(_UIIconHolder.default, {
    innerStyles: {
      lineHeight: 'inherit',
      verticalAlign: 'middle'
    },
    name: resultIcon,
    color: getIconColor(use),
    size: getIconSize(longhandSize)
  }));
};

var getComputedStyle = function getComputedStyle(style, grow, minHeight) {
  if (minHeight) {
    var computedStyle = (0, _extends2.default)({}, style, {
      minHeight: minHeight
    });
    if (!grow) computedStyle.height = '1rem';
    return computedStyle;
  }

  return style;
};

var UILoadingSpinner =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(UILoadingSpinner, _Component);

  function UILoadingSpinner(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UILoadingSpinner);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UILoadingSpinner).call(this, props));

    _this.handleDisplayResultFinish = function () {
      var onResultDisplayFinish = _this.props.onResultDisplayFinish;
      onResultDisplayFinish();
    };

    _this.getComputedStyle = (0, _memoizeOne.default)(getComputedStyle);
    _this.state = {
      displayResult: props.showResult
    };
    return _this;
  }

  (0, _createClass2.default)(UILoadingSpinner, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var showResult = this.props.showResult;

      if (showResult) {
        this.setResultDisplayTimeout();
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var showResult = nextProps.showResult;

      if (this.state.displayResult !== showResult) {
        this.setState({
          displayResult: showResult
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (!prevState.displayResult && this.state.displayResult) {
        this.setResultDisplayTimeout();
      } else if (prevState.displayResult && !this.state.displayResult) {
        clearTimeout(this.resultDisplayTimeout);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.resultDisplayTimeout);
    }
  }, {
    key: "setResultDisplayTimeout",
    value: function setResultDisplayTimeout() {
      var resultAnimationDuration = this.props.resultAnimationDuration;
      clearTimeout(this.resultDisplayTimeout);
      this.resultDisplayTimeout = setTimeout(this.handleDisplayResultFinish, resultAnimationDuration);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          failed = _this$props.failed,
          showResult = _this$props.showResult,
          __className = _this$props.className,
          dataLoading = _this$props['data-loading'],
          grow = _this$props.grow,
          label = _this$props.label,
          labelCompletedText = _this$props.labelCompletedText,
          layout = _this$props.layout,
          minHeight = _this$props.minHeight,
          __resultAnimationDuration = _this$props.resultAnimationDuration,
          resultIcon = _this$props.resultIcon,
          role = _this$props.role,
          use = _this$props.use,
          showLabel = _this$props.showLabel,
          size = _this$props.size,
          style = _this$props.style,
          __onResultDisplayFinish = _this$props.onResultDisplayFinish,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["className", "failed", "showResult", "className", "data-loading", "grow", "label", "labelCompletedText", "layout", "minHeight", "resultAnimationDuration", "resultIcon", "role", "use", "showLabel", "size", "style", "onResultDisplayFinish"]);
      var displayResult = this.state.displayResult;
      var computedLayout = layout || (grow ? 'centered' : 'inline');
      var computedLabelText = displayResult && !failed ? (0, _lazyEval.default)(labelCompletedText) : (0, _lazyEval.default)(label);
      var RenderedLabel = showLabel ? SpinnerLabel : 'span';
      var renderedLabelProps = {
        children: computedLabelText
      };

      if (showLabel) {
        renderedLabelProps.layout = computedLayout;
      } else {
        renderedLabelProps.className = 'sr-only';
      }

      var longhandSize = (0, _tshirtSize.toLonghandSize)(size);
      var spinnerSizePx = parseInt(getSpinnerSize(longhandSize), 10);
      return _react.default.createElement(SpinnerOuter, (0, _extends2.default)({}, rest, {
        className: getClassName(className, use, displayResult),
        style: this.getComputedStyle(style, grow, minHeight),
        "data-loading": dataLoading !== undefined ? dataLoading : !showResult,
        layout: computedLayout,
        grow: grow,
        role: role,
        use: use
      }), _react.default.createElement(SpinnerInner, {
        size: longhandSize
      }, _react.default.createElement(SpinnerWrapper, {
        displayResult: displayResult
      }, _react.default.createElement(Ring, {
        height: spinnerSizePx,
        viewBox: "0 0 50 50",
        width: spinnerSizePx,
        use: use
      }, _react.default.createElement(RingBackground, {
        cx: "25",
        cy: "25",
        r: "22.5",
        fill: "none",
        strokeWidth: "5",
        use: use
      }), _react.default.createElement(RingPath, {
        cx: "25",
        cy: "25",
        r: "22.5",
        fill: "none",
        strokeWidth: "5",
        use: use
      }))), renderIcon(failed, resultIcon, longhandSize, use, displayResult)), _react.default.createElement(RenderedLabel, renderedLabelProps));
    }
  }]);
  return UILoadingSpinner;
}(_react.Component);

UILoadingSpinner.displayName = 'UILoadingSpinner';
UILoadingSpinner.propTypes = {
  'data-loading': _propTypes.default.bool,
  failed: _propTypes.default.bool,
  showResult: _propTypes.default.bool,
  label: (0, _createLazyPropType.default)(_propTypes.default.node).isRequired,
  labelCompletedText: (0, _createLazyPropType.default)(_propTypes.default.node).isRequired,
  layout: _propTypes.default.oneOf(['inline', 'centered']),
  minHeight: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  grow: _propTypes.default.bool,
  resultAnimationDuration: _propTypes.default.number.isRequired,
  resultIcon: _propTypes.default.string,
  use: _propTypes.default.oneOf(Object.keys(_LoadingConstants.USE_CLASSES)),
  showLabel: _propTypes.default.bool.isRequired,
  size: (0, _tshirtSize.propTypeForSizes)(['xs', 'sm', 'md']),
  onResultDisplayFinish: _propTypes.default.func
};
UILoadingSpinner.defaultProps = {
  failed: false,
  grow: false,
  label: function label() {
    return _I18n.default.text('ui.UILoadingSpinner.busyText');
  },
  labelCompletedText: function labelCompletedText() {
    return _I18n.default.text('ui.UILoadingSpinner.completedText');
  },
  showResult: false,
  resultAnimationDuration: 1500,
  resultIcon: 'success',
  role: 'status',
  onResultDisplayFinish: _emptyFunction.default,
  showLabel: false,
  size: 'small',
  use: 'link'
};
var _default = UILoadingSpinner;
exports.default = _default;
module.exports = exports.default;